module.exports = __webpack_public_path__ + "img/logo_stregis@3x.42111e78.png";